<template>
  <div
    class="upsell-upgrade-cta flex items-center"
    data-testid="upsell-upgrade-cta"
  >
    <div class="upsell-upgrade-cta__pricing flex flex-col items-start">
      <div class="flex items-baseline">
        <OwnType
          class="upsell-upgrade-cta__price"
          :text="price"
          variant="title-regular"
        />
        <OwnType
          class="upsell-upgrade-cta__cadence"
          :text="t('upsell.price-cadence')"
          variant="paragraph-small"
        />
      </div>
      <OwnType
        class="upsell-upgrade-cta__cancel"
        :text="t('upsell.cancel-any-time')"
        variant="paragraph-very-small"
      />
    </div>
    <OwnButton
      class="upsell-upgrade-cta__button"
      :text="t('upsell.upgrade-cta')"
      variant="primary"
      data-testid="upsell-upgrade-cta-button"
      @click="emit('upgrade')"
    />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { OwnButton } from '@/ui/OwnButton'
import { OwnType } from '@/ui/OwnType'

import { useMaxUpsellContent } from '../composables/useMaxUpsellContent'

const emit = defineEmits<{
  upgrade: []
}>()

const { t } = useI18n({ useScope: 'global' })

const { price } = useMaxUpsellContent()
</script>

<style lang="scss" scoped>
// Specs from the tier-upgrades dark design (Figma node 428:26246) — fixed
// palette, not theme tokens, because it always sits on the dark upsell
// surface.
.upsell-upgrade-cta {
  padding: 8px 8px 8px 16px;
  border: 0.5px solid #484848;
  border-radius: 20px;
  background-image: linear-gradient(
    103deg,
    rgb(255 255 255 / 14.5%) 3.24%,
    rgb(86 174 221 / 22%) 49.5%,
    rgb(8 137 36 / 22%) 95.76%
  );
  box-shadow:
    0 7px 14px rgb(74 74 74 / 5%),
    0 26px 26px rgb(74 74 74 / 4%),
    0 59px 36px rgb(74 74 74 / 3%),
    0 105px 42px rgb(74 74 74 / 1%);

  &__pricing {
    min-width: 93px;
  }

  &__price {
    color: #fff;
    line-height: 22.4px;
  }

  &__cadence {
    color: #fff;
    line-height: 19.6px;
  }

  &__cancel {
    font-size: 10px;
    line-height: 14.4px;
    color: #9aa19d;
  }

  .upsell-upgrade-cta__button {
    min-width: 45px;
    min-height: 45px;
    border-radius: 12px;
    background: #0d0e0e;
    box-shadow:
      0 2px 5px rgb(60 66 87 / 8%),
      0 0 0 1px rgb(60 66 87 / 16%),
      0 1px 1px rgb(60 66 87 / 12%);

    :deep(.text-button-regular) {
      font-size: 0.875rem;
      line-height: 19.6px;
    }

    &:hover {
      background-color: #1b1d1c;
    }
  }
}
</style>
